import { appClipBannerCopy } from "../domain/appClip";

export function AppClipBanner() {
  return (
    <div
      className="flex items-start gap-3 rounded-xl border border-[#bed4c9] bg-[#e6f0eb] px-3 py-3 text-sm text-[#244d40]"
      data-testid="app-clip-banner"
      role="status"
    >
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#1f6b57] text-xs font-bold text-white">
        V
      </span>
      <div>
        <p className="font-semibold">Veto App Clip</p>
        <p className="mt-0.5 text-xs leading-relaxed text-[#36594d]">{appClipBannerCopy()}</p>
      </div>
    </div>
  );
}
